import type { Hookable } from 'hookable'

import type { KanbanBoardContextEvents } from '../useKanbanBoardContext.events.schema'

type KanbanBoardContextHookMap = {
  [K in keyof KanbanBoardContextEvents]: (event: KanbanBoardContextEvents[K]) => void | Promise<void>
}

/**
 * Handle for removing a previously registered kanban board context hook.
 */
type KanbanBoardContextUnsubscribe = () => void

interface KanbanBoardContextLoggerLike {
  debug: (message: string, meta?: Record<string, unknown> | unknown) => void
}

interface UseKanbanBoardContextOnBoardIdChangedParams {
  hooks: Hookable<KanbanBoardContextHookMap>
  logger: KanbanBoardContextLoggerLike
}

/**
 * Internal handler: provides a centralized hook point for board route changes.
 */
export default function useKanbanBoardContextOnBoardIdChanged({
  hooks,
  logger,
}: UseKanbanBoardContextOnBoardIdChangedParams) {
  const unsubscribe: KanbanBoardContextUnsubscribe = hooks.hook(
    'BoardIdChanged',
    ({ boardId, previousBoardId, path }) => {
      logger.debug('Kanban board route param changed', {
        path,
        previousBoardId,
        boardId,
      })
    },
  )

  return unsubscribe
}
